import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Funciona si mi hijo es muy terco?',
  answer: 'Sí, el método de conexión elimina la lucha de poder.'
}, {
  question: '¿Necesito estar en casa todo el tiempo?',
  answer: 'Para los primeros 2 días, sí. El tercer día incluimos la salida guiada.'
}, {
  question: '¿Es un libro físico?',
  answer: 'No, es un producto digital de acceso inmediato para que empieces hoy mismo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-slate mb-4" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-30">
                <span className="font-bold text-lg text-slate pr-8" data-id="element-31">
                  {faq.question}
                </span>
                <ChevronDown className={`text-teal transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-32" />
              </button>

              <AnimatePresence data-id="element-33">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-34">
                    <div className="px-6 pb-5 text-slate-light text-lg" data-id="element-35">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}